module.exports = __webpack_public_path__ + "img/transport-belt-connector-frame-main-scanner-sw-se.bf96065c.png";